/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __extends } from "tslib";
import { alCallProperty, } from '../runtime';
import { wrapAVM1NativeClass } from './AVM1Utils';
import { AVM1Object } from '../runtime/AVM1Object';
var AVM1Key = /** @class */ (function (_super) {
    __extends(AVM1Key, _super);
    function AVM1Key() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AVM1Key.createAVM1Class = function (context) {
        var wrapped = wrapAVM1NativeClass(context, false, AVM1Key, ['BACKSPACE', 'CAPSLOCK', 'CONTROL', 'DELETEKEY', 'DOWN',
            'END', 'ENTER', 'ESCAPE', 'HOME', 'INSERT', 'LEFT',
            'PGDN', 'PGUP', 'RIGHT', 'SHIFT', 'SPACE', 'TAB', 'UP', 'isDown', 'getCode', 'getAscii'], []);
        return wrapped;
    };
    AVM1Key.alInitStatic = function (context) {
        this._keyStates = [];
        this._lastKeyCode = 0;
    };
    AVM1Key.bindStage = function (context, cls, stage, htmlElement) {
        // TODO: should be listening on MouseManager for key-input ?
        if (AVM1Key.keyDownDelegate)
            htmlElement.removeEventListener('keydown', AVM1Key.keyDownDelegate);
        if (AVM1Key.keyUpDelegate)
            htmlElement.removeEventListener('keyup', AVM1Key.keyUpDelegate);
        AVM1Key.keyDownDelegate = function (e) {
            var staticState = context.getStaticState(AVM1Key);
            staticState._lastKeyCode = e.keyCode;
            staticState._keyStates[e.keyCode] = 1;
            alCallProperty(cls, 'broadcastMessage', ['onKeyDown']);
        };
        AVM1Key.keyUpDelegate = function (e) {
            var staticState = context.getStaticState(AVM1Key);
            staticState._lastKeyCode = e.keyCode;
            delete staticState._keyStates[e.keyCode];
            alCallProperty(cls, 'broadcastMessage', ['onKeyUp']);
        };
        htmlElement.addEventListener('keydown', AVM1Key.keyDownDelegate);
        htmlElement.addEventListener('keyup', AVM1Key.keyUpDelegate);
    };
    AVM1Key.isDown = function (context, code) {
        var staticState = context.getStaticState(AVM1Key);
        return !!staticState._keyStates[code];
    };
    AVM1Key.getCode = function (context) {
        var staticState = context.getStaticState(AVM1Key);
        return staticState._lastKeyCode;
    };
    AVM1Key.getAscii = function (context) {
        // really this is not same, but charCode depricated and emmited only on keypress (after keyDown)
        // that can't be used for us
        // keycode similar while meta keys not used
        var staticState = context.getStaticState(AVM1Key);
        return staticState._lastKeyCode;
    };
    AVM1Key.BACKSPACE = 8;
    AVM1Key.CAPSLOCK = 20;
    AVM1Key.CONTROL = 17;
    AVM1Key.DELETEKEY = 46;
    AVM1Key.DOWN = 40;
    AVM1Key.END = 35;
    AVM1Key.ENTER = 13;
    AVM1Key.ESCAPE = 27;
    AVM1Key.HOME = 36;
    AVM1Key.INSERT = 45;
    AVM1Key.LEFT = 37;
    AVM1Key.PGDN = 34;
    AVM1Key.PGUP = 33;
    AVM1Key.RIGHT = 39;
    AVM1Key.SHIFT = 16;
    AVM1Key.SPACE = 32;
    AVM1Key.TAB = 9;
    AVM1Key.UP = 38;
    AVM1Key.keyDownDelegate = null;
    AVM1Key.keyUpDelegate = null;
    return AVM1Key;
}(AVM1Object));
export { AVM1Key };
